import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaxonomyFunctionItem } from './taxonomyTypes';

export type TaxonomyState = {
  data: TaxonomyFunctionItem[];
  loading: boolean;
  error: string | null;
  customUseCases: any[];
};

const initialState: TaxonomyState = {
  data: [],
  loading: false,
  error: null,
  customUseCases: [],
};

export const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState,
  reducers: {
    setTaxonomies: (state, action: PayloadAction<TaxonomyFunctionItem[]>) => {
      state.data = action.payload;
    },
    setCustomUseCases: (state, action: PayloadAction<any[]>) => {
      state.customUseCases = action.payload;
    },
    resetTaxonomies: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.customUseCases = [];
    },
  },
});

export const { resetTaxonomies, setTaxonomies, setCustomUseCases } = taxonomySlice.actions;
export default taxonomySlice.reducer;
